import 'react-app-polyfill/ie11'; 
import 'react-app-polyfill/stable';

import 'core-js';

import React from 'react';

import ReactDOM from 'react-dom';

import { NotificationContainer } from "react-notifications";
import 'react-notifications/lib/notifications.css';

import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App';
import * as serviceWorker from './serviceWorker';

import { icons } from './assets/icons'

import { Provider } from 'react-redux'

import store from './store'
import { OperatingModeProvider } from './context/OperatingModeContext';

React.icons = icons

ReactDOM.render(
  <Provider store={store}>
    <OperatingModeProvider>
      <NotificationContainer />
      <App/>
    </OperatingModeProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
